import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Control from "./pages/Control";
import Overlay from "./pages/Overlay";
import Teams from "./pages/Teams";
import LineupSubmit from "./pages/LineupSubmit";
import Commentator from "./pages/Commentator";
import FourthOfficial from "./pages/FourthOfficial";
import AdminPanel from "./pages/AdminPanel";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center">
        <div className="text-white font-body">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Wrapper to conditionally render Toaster
const AppContent = () => {
  const location = useLocation();
  const isOverlay = location.pathname.startsWith('/overlay');
  
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/control/:gameId" element={
          <ProtectedRoute>
            <Control />
          </ProtectedRoute>
        } />
        <Route path="/teams" element={
          <ProtectedRoute>
            <Teams />
          </ProtectedRoute>
        } />
        {/* Public overlay route - no auth required */}
        <Route path="/overlay/:gameId" element={<Overlay />} />
        {/* Public lineup submission - no auth required */}
        <Route path="/lineup" element={<LineupSubmit />} />
        {/* Public commentator page - no auth required */}
        <Route path="/commentator" element={<Commentator />} />
        {/* Public 4th official page - no auth required */}
        <Route path="/fourth-official" element={<FourthOfficial />} />
        {/* Admin panel - admin only */}
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        } />
      </Routes>
      {!isOverlay && <Toaster position="top-center" richColors />}
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
